"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnyVariantAdded = exports.isAnyProductVariable = exports.isAnyProductAvailableOrOrdered = exports.isAnyProductAvailableAndHasAnyVariants = exports.getDefaultImage = exports.areAllProductsAdded = void 0;
var _formatting = require("./formatting");
var isAnyVariantAdded = exports.isAnyVariantAdded = function isAnyVariantAdded(extras) {
  return extras.some(function (extra) {
    return extra.productVariants.some(function (variant) {
      return !!variant.ordered;
    });
  });
};
var areAllProductsAdded = exports.areAllProductsAdded = function areAllProductsAdded(extras) {
  return extras.every(function (extra) {
    return extra.product.available ? extra.productVariants.some(function (variant) {
      return !!variant.ordered;
    }) : true;
  });
};
var getDefaultImage = exports.getDefaultImage = function getDefaultImage(type, copy) {
  var camelCaseType = (0, _formatting.camelCase)(type);
  return copy[camelCaseType] && copy[camelCaseType].image || null;
};
var isAnyProductAvailableAndHasAnyVariants = exports.isAnyProductAvailableAndHasAnyVariants = function isAnyProductAvailableAndHasAnyVariants(extras) {
  return extras.some(function (extra) {
    return !!extra.productVariants.length && extra.product.available;
  });
};
var isAnyProductAvailableOrOrdered = exports.isAnyProductAvailableOrOrdered = function isAnyProductAvailableOrOrdered(extras) {
  return isAnyProductAvailableAndHasAnyVariants(extras) || isAnyVariantAdded(extras);
};
var isAnyProductVariable = exports.isAnyProductVariable = function isAnyProductVariable(extras) {
  return !!extras.find(function (extra) {
    return extra.product.variableExtra;
  });
};